// MUI
import {Avatar} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

export const UserAvatar = ({bgColor, size, textColor, user}) => {
  return (
    <Avatar
      alt={'Jared'}
      sx={{
        backgroundColor: bgColor,
        color: textColor,
        fontSize: '14px',
        fontWeight: 'bold',
        height: size,
        width: size,
      }}
    >
      {user.firstName[0]}
    </Avatar>
  );
};

UserAvatar.propTypes = {
  bgColor: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  textColor: PropTypes.string,
  user: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string,
    pictureUrl: PropTypes.string,
  }).isRequired,
};
